const accountDetails = {
  accountDetails: {
    managePreferences: 'Changez vos préférences',
    email: 'E-mail',
    emailChangeText: 'Vous devez encore confirmer la modification de votre adresse électronique!',
    confirmationText: 'Nous avons envoyé un message électronique de confirmation à %{email}. Vous devez cliquer sur le lien de ce message pour que la modification de votre adresse électronique soit prise en compte.',
    resendConfirmationEmail: 'Renvoyer le message électronique de confirmation',
    cancelChange: 'Annuler cette modification',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    company: "Nom de l'entreprise",
    saveDetails: 'Enregistrer les détails sur le compte',
    changeEmailRequest: "Changer l'e-mail",
    job_profile: {
      label: "Sélectionnez le profil professionnel de la personne dans l'entreprise",
      tooltip_msg: 'Sélectionnez le profil professionnel principal de la personne. Si l\'utilisateur a plus d\'un rôle principal, sélectionnez "Autres"'
    }
  },
  resetPassword: {
    instructions: 'Votre mot de passe doit comporter au moins six caractères, doit contenir au moins un chiffre ou un caractère spécial et ne peut pas être identique à votre adresse électronique.',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Entrer le mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
  }
};

export default accountDetails;